<script lang="ts">
	import X from '@lucide/svelte/icons/x'

	import { page } from '$app/state'
	import { Button } from '#lib/components/ui/button/index.js'
	import { phg, hashToOption } from '#lib/utils/posthog.js'
	import Cmc from '~icons/simple-icons/coinmarketcap'
	import LinkedIn from '~icons/simple-icons/linkedin'
	import Twitter from '~icons/simple-icons/x'

	let { open = $bindable() } = $props()

	const CHANNELS = [
		{
			id: 'x',
			Icon: Twitter,
			text: 'Be first to know when a chain makes its move. Live alerts on our X, daily',
			cta: 'Follow on X',
			href: 'https://x.com/chainspect_app',
			event: 'twitter_banner_click',
		},
		{
			id: 'linkedin',
			Icon: LinkedIn,
			text: "Be first to spot a chain's next move. Daily data insights on our LinkedIn",
			cta: 'Follow on LinkedIn',
			href: 'https://www.linkedin.com/company/107397610',
			event: 'linkedin_banner_click',
		},
		{
			id: 'cmc',
			Icon: Cmc,
			text: 'Be first to know when a network sets a record. Live updates on CoinMarketCap',
			cta: 'Follow on CoinMarketCap',
			href: 'https://coinmarketcap.com/community/profile/chainspect_app',
			event: 'cmc_banner_click',
		},
	] as const

	const channel = $derived(
		CHANNELS[hashToOption(page.data.user && `${page.data.user}:bottom-toast`, CHANNELS.length) - 1]
	)
</script>

{#if open}
	<div
		class="bg-card border-branding-blue fixed right-4 bottom-4 left-4 z-50 flex max-w-full flex-col items-start gap-4 rounded-lg border p-4 shadow-lg sm:left-auto sm:max-w-94"
	>
		<Button
			class="absolute top-0.5 right-0.5"
			aria-label="Close"
			onclick={() => (open = false)}
			size="icon-sm"
			variant="ghost"
		>
			<X />
		</Button>

		<div class="flex items-center gap-1 pr-2.5">
			<div class="flex items-center justify-center p-3">
				<channel.Icon class="size-6" height="24" width="24" />
			</div>

			<p class="text-sm">{channel.text}</p>
		</div>

		<Button
			class="w-full"
			href={channel.href}
			onclick={() => {
				open = false
				phg.capture(channel.event)
			}}
			rel="noopener noreferrer"
			target="_blank"
			variant="brand"
		>
			{channel.cta}
		</Button>
	</div>
{/if}
